export default __webpack_public_path__ + "static/media/big_head_-1.361c36d6.webp";